"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../../decorators/Controllable"));

var _HoverProvider = _interopRequireDefault(require("../../providers/HoverProvider"));

var _UIAbstractDropdown = _interopRequireDefault(require("../abstract/UIAbstractDropdown"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _Selectors = require("../../constants/Selectors");

var _Dom = require("../../utils/Dom");

var _underscore = require("../../utils/underscore");

var _renderMultiLevelMenu = require("../utils/renderMultiLevelMenu");

var _Functions = require("../../core/Functions");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &&& {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SubDropdown = (0, _styledComponents.default)(_UIAbstractDropdown.default).withConfig({
  displayName: "SubDropdownMenu__SubDropdown",
  componentId: "odntaa-0"
})(_templateObject(), function (_ref) {
  var open = _ref.open;
  return open ? _colors.GYPSUM : null;
});
SubDropdown.displayName = 'SubDropdownMenu__SubDropdown';

var RightCaret = function RightCaret() {
  return _react.default.createElement(_UIIcon.default, {
    name: "right",
    size: "xxs",
    color: _colors.EERIE
  });
};

var SubDropdownMenu =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SubDropdownMenu, _PureComponent);

  function SubDropdownMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SubDropdownMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubDropdownMenu).call(this, props));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDownOnMenu = _this.handleKeyDownOnMenu.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUpOnMenu = _this.handleKeyUpOnMenu.bind((0, _assertThisInitialized2.default)(_this));
    _this.menuRefCallback = _this.menuRefCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SubDropdownMenu, [{
    key: "getComputedOpen",
    value: function getComputedOpen() {
      var _this$props = this.props,
          menuHovered = _this$props.menuHovered,
          open = _this$props.open;
      return open || this._hovered || menuHovered;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var key = evt.key;
      var onMenuHoveredChange = this.props.onMenuHoveredChange;

      if (key === 'ArrowRight' || key === 'Enter' || key === ' ') {
        // allow Enter to open menu without closing entire dropdown
        if (!this.getComputedOpen() && key === 'Enter') evt.preventDefault();
        onMenuHoveredChange((0, _SyntheticEvent.default)(true));
        evt.stopPropagation();
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(evt) {
      var key = evt.key;

      if (key === 'ArrowRight' || key === 'Enter' || key === ' ') {
        // focus the first item in the submenu after opening
        var firstChild = this._menuEl.querySelector('li');

        if (firstChild) {
          firstChild.children[0].focus();
        }

        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  }, {
    key: "handleKeyUpOnMenu",
    value: function handleKeyUpOnMenu(evt) {
      var key = evt.key;
      var onMenuHoveredChange = this.props.onMenuHoveredChange; // stopPropagation to prevent UIAbstractDropdown from closing ~all menus~ on Escape

      if (key === 'Escape') {
        onMenuHoveredChange((0, _SyntheticEvent.default)(false));
        evt.stopPropagation();
        return;
      }
    }
  }, {
    key: "handleKeyDownOnMenu",
    value: function handleKeyDownOnMenu(evt) {
      var key = evt.key;
      var onMenuHoveredChange = this.props.onMenuHoveredChange;
      if (!this.getComputedOpen()) return;

      if (key === 'ArrowLeft') {
        onMenuHoveredChange((0, _SyntheticEvent.default)(false)); // prevents closing ~all~ submenus on ArrowLeft

        evt.stopPropagation();
        return;
      } // Up/Down arrow handling like in UIDropdown


      if (key === 'ArrowDown' || key === 'ArrowUp') {
        var allMenuItems = this._menuEl.querySelectorAll('li');

        if (allMenuItems.length === 0) return;
        var currentMenuItem = (0, _Dom.closest)(document.activeElement, 'li');
        var nextMenuItem = key === 'ArrowDown' ? currentMenuItem && currentMenuItem.nextSibling || allMenuItems[0] : currentMenuItem && currentMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);

        while (nextMenuItem !== currentMenuItem) {
          var focusTarget = nextMenuItem.querySelector(_Selectors.FOCUSABLE);

          if (focusTarget) {
            evt.preventDefault();
            focusTarget.focus();
            break;
          }

          nextMenuItem = key === 'ArrowDown' ? nextMenuItem.nextSibling || allMenuItems[0] : nextMenuItem.previousSibling || (0, _underscore.last)(allMenuItems);
        }

        evt.stopPropagation();
      }
    }
  }, {
    key: "menuRefCallback",
    value: function menuRefCallback(ref) {
      this._menuEl = ref;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(_ref2) {
      var _this2 = this;

      var options = _ref2.options,
          groupType = _ref2.groupType,
          value = _ref2.value,
          onChange = _ref2.onChange;
      var updatedOptions = options; // don't do anything special if not handling the radio/"selectable" case

      if (groupType === 'radio') {
        updatedOptions = updatedOptions.map(function (item) {
          var option = (0, _extends2.default)({}, item);
          option.selected = value === item.value; // copy any existing onClick behavior on option and merge in value change behavior

          option.onClick = function (evt) {
            // keep the menu open by ensuring the parent menu doesn't handle closing
            evt.preventDefault();
            evt.stopPropagation(); // only trigger when value changes

            if (_this2.props.value !== option.value) {
              onChange((0, _SyntheticEvent.default)(option.value));
            }

            (0, _Functions.callIfPossible)(item.onClick, evt);
          };

          return option;
        });
      }

      return (0, _renderMultiLevelMenu.renderMenu)(updatedOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          defaultValue = _this$props2.defaultValue,
          dropdownClassName = _this$props2.dropdownClassName,
          groupType = _this$props2.groupType,
          __hovered = _this$props2.hovered,
          __menuHovered = _this$props2.menuHovered,
          onMenuHoveredChange = _this$props2.onMenuHoveredChange,
          options = _this$props2.options,
          popoverProps = _this$props2.popoverProps,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "defaultValue", "dropdownClassName", "groupType", "hovered", "menuHovered", "onMenuHoveredChange", "options", "popoverProps", "value", "onChange"]);
      var computedDropdownClassName = (0, _classNames.default)(className, dropdownClassName, 'private-dropdown--list');
      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        _this3._hovered = hovered;

        var computedOpen = _this3.getComputedOpen();

        return _react.default.createElement(SubDropdown, (0, _extends2.default)({}, rest, hoverProviderRestProps, {
          popoverProps: (0, _extends2.default)({
            _distanceAdjustment: -4,
            _insetAdjustment: 4
          }, popoverProps, {
            onMouseEnter: function onMouseEnter() {
              return onMenuHoveredChange((0, _SyntheticEvent.default)(true));
            },
            onMouseLeave: function onMouseLeave() {
              return onMenuHoveredChange((0, _SyntheticEvent.default)(false));
            },
            onKeyDown: _this3.handleKeyDownOnMenu,
            onKeyUp: _this3.handleKeyUpOnMenu
          }),
          caretRenderer: RightCaret,
          dropdownClassName: computedDropdownClassName,
          placement: "right bottom",
          open: computedOpen,
          onKeyUp: _this3.handleKeyUp,
          onKeyDown: _this3.handleKeyDown // mount animation looks off - keep disabled for now
          ,
          animateOnToggle: false,
          autoPlacement: "horiz"
        }), _react.default.createElement("div", {
          ref: _this3.menuRefCallback
        }, _this3.renderChildren({
          options: options,
          groupType: groupType,
          value: value || defaultValue,
          onChange: onChange
        })));
      });
    }
  }]);
  return SubDropdownMenu;
}(_react.PureComponent);

SubDropdownMenu.propTypes = (0, _extends2.default)({}, _UIAbstractDropdown.default.propTypes, {
  groupType: _react.PropTypes.oneOf(['none', 'radio']),
  hovered: _react.PropTypes.bool,
  open: _react.PropTypes.bool,
  value: _react.PropTypes.string
});
SubDropdownMenu.defaultProps = (0, _extends2.default)({}, _UIAbstractDropdown.default.defaultProps, {
  groupType: 'none',
  menuWidth: 'auto'
});
SubDropdownMenu.displayName = 'SubDropdownMenu';

var _default = (0, _Controllable.default)(SubDropdownMenu, ['menuHovered', 'value']);

exports.default = _default;
module.exports = exports.default;